module.exports = {
  MenuManagement: '菜单管理',
  CustomerMenu: '客户菜单',
  CustomerAutomation: '客户自动化',
  Search: '搜索',
  PleaseEnterChinese: '请输入中文、英文、代码',
  AddMenu: '新增菜单',
  UpdateMenu: '修改菜单',
  AddCustomerMenu: '新增客户菜单',
  Refresh: '刷新',
  ChineseName: '中文名',
  EnglishName: '英文名',
  Coding: '编码',
  Icon: '图标',
  Node: '节点',
  ParentNode: '父节点',
  Order: '顺序',
  ModuleFile: '模块文件',
  H5Url: 'H5地址',
  Type: '类型',
  Module: '模块',
  Component: '组件',
  Add: '新增',
  Update: '修改',
  Save: '保存',
  Cancel: '取消',
  OK: '确定',
  ChineseCanNotBeEmpty: '中文不能为空',
  EnglishCanNotBeEmpty: '英文不能为空',
  TheEncodingCanNotBeEmpty: '编码不能为空',
  SavedSuccess: '保存成功',
  PleaseSelectTheMenu: '请选择菜单',
  PleaseSelectTheCustomer: '请选择客户',
  NoCustomersWantToAdd: '没有客户要新增',
  Prompt: '提示',
  Removed: '移除',
  Numbering: '编号',
  delete: '删除',
  CompanyChineseName: '中文名称',
  SuccessfullyDeleted: '删除成功',
  DeleteData: '请选择需要删除的客户',
  UpdateData: '请选择需要修改客户信息',
  InitData: '请选择需要查看初始化基础数据客户',
  SearchTitle: '请输入公司名称或公司代码查询',
  BasicData: '基础数据',
  ExpiredCustomerNotification: '客户到期通知',
  CompanyName: '公司名称',
  CompanyCode: '公司代码',
  CompanyPhone: '公司电话',
  CompanyEMail: '公司邮箱',
  CompanyFax: '公司传真',
  CreateDate: '创建时间',
  GroupCompany: '集团公司',
  InitializeCustomer: '注册公司',
  copy: '请选择需要复制的环境',
  InitializeData: '初始化基础数据',
  InitializeMenu: '初始化菜单',
  CompanyNamePrompt: '公司名称为必填',
  mailbox: '管理员邮箱为必填',
  UpdateSuccess: '修改信息成功',
  Initialized: '初始化成功',
  CompanyAddress: '公司地址',
  AdminChineseName: '管理员中文名',
  AdminEnglishName: '管理员英文名',
  email: '管理员邮箱',
  phone: '管理员电话',
  Current: '公司编号',
  StandardLibrary: '标准环境',
  Next: '下一步',
  Back: '上一步',
  Finish: '完成',
  Initialize: '初始化',
  Harbour: '海港',
  Airport: '空港',
  ChargesItems: '收费项目',
  AirRoute: '航线',
  NetWork: '网络',
  Currency: '币种',
  EQType: '箱种',
  Packing: '包装',
  HouseBlType: '提单类型',
  CargoType: '货物类型',
  IncoTerm: '贸易条款',
  ShippingTerm: '运输条款',
  TradeTerm: '贸易方式',
  CustomerType: '客户类型',
  PortGroup: '关联港口',
  OtherChargeItem: '空运运单杂费',
  ShippingCompaniesAirlines: '船公司、航空公司',
  Template: '模版',
  AirService: '空运运费服务项目',
  BlMode: '提单方式',
  CustomJobType: '自定义业务类型',
  TransmitFileType: '流转文件类型',
  copyTenantId: '请选择需要复制的环境',
  imgToolTip: '填写公司及系统管理员信息\n管理员邮箱为登录凭证',
  imgToolTip2: '需要复制的模版',
  imgToolTip3: '平台基础数据',
  imgToolTip4: '平台菜单',
  Sequence: '序列',
  documentCategory: '文件类型管理',
  charegeUnit: '计费单位/单位',
  BusinessStatus: '业务状态管理',
  PermissionConfig: '权限配置',
  Report: '报表',
  ConfigurationManagement: '配置管理',
  SingleOnlineSet: '在线对单设置',
  IsH5Open: 'H5是否开放',
  CopySetting: '复制配置',
  AllOpen: '全部开放',
  AllClose: '全部不开放',
  Start: '开始',
  StandardLibrary2: '标准库',
  OnlineCustomerService: '在线客服',
  SubmitATicket: '提交工单',
  CheckTheTicket: '查看工单',
  Menu1: '菜单',
  HelpCenter: '帮助中心',
  HelpVideo: '帮助视频',
  SystemOperationGuidance: '系统操作引导',
  InitializeBoot: '初始化引导',
  SpareQQ: '备用QQ',
  SettingsAndTools: '设置与工具',
  ReportStatistics: '报表统计',
  Weibo: '微博',
  LogInformation: '日志信息',
  BillingSystem: '计费系统',
  UnbindWeChat: '微信解绑',
  SystemInformation: '系统信息',
  SignOut: '退出登录',
  WallTechFamily: '沃行之家',
  Notice: '提醒',
  ClearLog: '清除日志',
  UploadLog: '上传日志',
  AuthorizationToken: '授权令牌:',
  LogLevel: '日志等级:',
  Source: '来源',
  AccountInformation: '账户信息',
  ShowYourAccountNumberAndTheCompaniesAndDepartmentsToWhichYouBelongHere: '此处显示您的账号及所隶属的公司和部门',
  InStationMessageReminder: '站内消息提醒',
  WhenYouHaveAPendingTaskThereWillBeAToDoNumberOnTheBellToRemindYouToDealWithItInTime: '当您有待处理任务时，铃铛上会有待办数量提醒您及时处理',
  ClickHereToEnterWallTechFamilyToViewYourOrderTrainingVideosAndOtherInformation: '点击此处可进入沃联之家，查看您的订单及培训视频等信息',
  WhenYouEncounterProblemsWithYourOperatingSystemYouCanContactOurOnlineCustomerServiceAtAnyTime: '当您操作系统遇到问题时，可随时联系我们在线客服',
  MultilingualSwitching: '多语言切换',
  SwitchDifferentLanguages: '切换不同语言',
  HereIsAHelpfulCenterSystemRelatedConfigurationToolsReportStatisticsBillingSystemAndOtherMoreInformation: '此处有帮助中心,系统相关配置工具，报表统计，计费系统等更多信息',
  OperationArea: '作业区',
  HereIsTheOperationInterfaceForYourDailyWork: '此处为您日常工作的操作界面',
  MenuBar: '菜单栏',
  TheSystemModuleMenuBarDisplayedHereMatchesThePermissionsOfYourLoginAccount: '此处显示的为与您登录账号权限匹配的系统模块菜单栏',
  More: '更多',
  Skip: '跳过',
  WeChatUnbindingFailed: '微信解绑失败',
  WhetherToConfirmWeChatUnbinding: '是否确认微信解绑?',
  Unbind: '取消解绑',
  WeChatUnbindingSuccessfully: '微信解绑成功',
  DearYouHaventBoundYourWeChatAccountYet: '亲,您尚未绑定微信号',
  AdministratorInitializationOperationGuidance: '管理员初始化操作引导',
  ImproveEnterpriseInformation: '完善企业信息',
  PleaseImproveYourCompanyEnterpriseInformation: '请完善您本公司企业信息',
  CreateAUser: '创建用户',
  CreateOurUsersAndSetPermissions: '创建本公司用户并设置权限',
  CustomerDataImport: '客商资料导入',
  InitializeAndImportTheCompanyOriginalCustomerInformation: '初始化导入本公司原有客商资料',
  ViewTheSteps: '查看操作步骤',
  YouAreNotAuthorizedToUseStatisticalAnalysisFunction: '你没有被授权使用统计分析功能'
}
